/** Approximate glyph width as a fraction of font size for bold tabular figures. */
const CENTER_LABEL_CHARACTER_WIDTH_RATIO = 0.62;
/** Padding inside the inner chart area so labels do not touch the arc. */
const CENTER_LABEL_SPACE_PADDING = 0.9;

export const PIE_CHART_CENTER_LABEL_MIN_FONT_SIZE = 20;
export const PIE_CHART_CENTER_LABEL_MAX_FONT_SIZE = 48;

export function getPieChartCenterLabelFontSize({
  innerRadius,
  label,
  minFontSize = PIE_CHART_CENTER_LABEL_MIN_FONT_SIZE,
  maxFontSize = PIE_CHART_CENTER_LABEL_MAX_FONT_SIZE,
  halfMode,
}: {
  innerRadius: number;
  label: string;
  minFontSize?: number;
  maxFontSize?: number;
  halfMode: boolean;
}): number {
  if (innerRadius <= 0) {
    return minFontSize;
  }

  const characterCount = Math.max(label.length, 1);
  const innerDiameter = innerRadius * 2;
  const widthLimit =
    (innerDiameter * CENTER_LABEL_SPACE_PADDING) /
    (characterCount * CENTER_LABEL_CHARACTER_WIDTH_RATIO);
  const heightLimit = halfMode
    ? innerRadius * CENTER_LABEL_SPACE_PADDING
    : innerDiameter * CENTER_LABEL_SPACE_PADDING * 0.5;
  const sizeBySpace = Math.min(heightLimit, widthLimit);

  return Math.max(minFontSize, Math.min(maxFontSize, Math.floor(sizeBySpace)));
}
